import {
  BookOpen,
  School,
  Users,
  UserCheck,
  MapPin,
  GraduationCap,
  Shield
} from 'lucide-react';
import type { Perfil } from '../types';
import { PERFIL_INFO } from '../constants';

export const getPerfilIcon = (perfilId: string) => {
  const info = PERFIL_INFO[perfilId];
  if (info) return info.icon;
  const idLower = perfilId.toLowerCase();
  if (idLower.includes('prof')) return BookOpen;
  if (idLower.includes('dir') || idLower.includes('esco')) return School;
  if (idLower.includes('secr') || idLower.includes('equip')) return Users;
  if (idLower.includes('coord')) return UserCheck;
  if (idLower.includes('pref') || idLower.includes('muni')) return MapPin;
  if (idLower.includes('est') || idLower.includes('regi')) return MapPin;
  if (idLower.includes('resp') || idLower.includes('fam')) return Users;
  if (idLower.includes('alun')) return GraduationCap;
  if (idLower.includes('adm') || idLower.includes('mast')) return Shield;
  return BookOpen; // fallback
};

export const getPerfilLabel = (perfil: Perfil) => {
  return perfil.nome || PERFIL_INFO[perfil.id]?.label || perfil.id;
};

export const getPerfilDesc = (perfil: Perfil) => {
  return (perfil as any).descricao || PERFIL_INFO[perfil.id]?.desc || 'Sem descrição cadastrada.';
};
